import { render } from "./Results.vue?vue&type=template&id=903cd236&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=903cd236&scoped=true&lang=css"

import exportComponent from "D:\\Coding\\welikethespeech\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-903cd236"]])

export default __exports__